/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Renki API Public
 * V1 of the renki API.
 * OpenAPI spec version: 1.0
 */
import useSwr from 'swr';
import type { Arguments, Key, SWRConfiguration } from 'swr';

import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';

import type {
    AccountGetFederatedIdentityResponseDTO,
    AccountGetSessionsResponseDTO,
    AccountGetUserAccountResponseDTO,
    AccountGetUserGDPRRequestResponseDTO,
    AccountMicrosoftTokenResponseDTO,
    AccountPutUserAccountRequestDTO,
    AnalyticsGetRenkiCountResponseDTO,
    AnalyticsGetSimpleSACountResponseDTO,
    CalendarUpdateWorkTimeCalendarScheduleRequestDTO,
    CalendarWorkTimeCalendarDTO,
    CalendarWorktimeCalendarScheduleCreateRequestDTO,
    DeleteIntegrationParams,
    DeleteScheduledNotificationParams,
    DevicespecsDTO,
    DevicespecsListBrandsResponseDTO,
    DevicespecsSearchModelResponseDTO,
    GetDeviceInstallationMetadataParams,
    GetDeviceParams,
    GetDeviceSpecByModelAndBrandParams,
    GetDevicesParams,
    GetHiddenTimeParams,
    GetInstanceDevicesByInstanceIDParams,
    GetLayersParams,
    GetRenkiCountParams,
    GetSimpleSACountParams,
    GetTauriUpdateParams,
    GetUserDeviceGroupsLastSeenParams,
    GetWorktimeCalendarScheduleParams,
    HiddentimeCreateRequestDTO,
    HiddentimeDTO,
    InstanceDTO,
    InstancePublicInstance,
    InstanceUpdateInstancePointRequestDTO,
    IntegrationsCreateIntegrationRequestDTO,
    IntegrationsIntegrationDTO,
    IntegrationsListIntegrationsDTO,
    IotassetClaimIoTAssetDTO,
    IotassetHasIoTAssetPermissionsResponseDTO,
    IotassetIoTAssetDTO,
    IotassetListRenkiIoTAssetsResponseDTO,
    IotassetRenkiIoTAssetDTO,
    IotassetUpdateIoTAssetUserFieldsDTO,
    IssueCreateDTO,
    ListAllOwnedIoTAssetsParams,
    ListAllOwnedTagsParams,
    ListIntegrationsParams,
    ListRenkiIoTAssetsParams,
    ListRenkiTagsParams,
    ScreenClaim,
    ScreenRegistration,
    ScreenReleaseScreenRequestDTO,
    ScreenState,
    SearchModelParams,
    SensorAreaDTO,
    SensorCreateAreaRequestDTO,
    SensorCreateAreaResponseDTO,
    SensorCreateLayerRequestDTO,
    SensorFirstScanRequestDTO,
    SensorFirstScanResponseDTO,
    SensorGetDeviceResponseDTO,
    SensorInstanceDeviceResponseDTO,
    SensorLayerDTO,
    SensorMACScanRequestDTO,
    SensorMACScanResponse,
    SensorUpdateAreaRequestDTO,
    SensorUpdateDeviceLayerRequestDTO,
    SensorUpdateDeviceLayerResponseDTO,
    SensorUpdateInstanceDeviceRequestDTO,
    TagAddTagLinkDTO,
    TagClaimTagDTO,
    TagHasRedirectPermissionsResponseDTO,
    TagListRenkiTagsResponseDTO,
    TagReleaseTagRequestDTO,
    TagRenkiTagDTO,
    TagRenkiTagTypeDTO,
    TagTagLinkResponseDTO,
    TauriupdateDTO,
    TosDTO,
    UserActiveInstanceResponseDTO,
    UserAllInstallationsMetadataDTO,
    UserCreateDeviceGroupAddressesBodyDTO,
    UserCreateDeviceGroupAddressesBodyHashedDTO,
    UserCreateDeviceGroupRequestDTO,
    UserDeviceGroupDTO,
    UserDeviceGroupsLastSeenDTO,
    UserInstallationMetadataDTO,
    UserUIDeviceGroupResponseDTO,
    UserUpdateDeviceGroupRequestBodyDTO,
    UtilHttpError,
} from './model';

import getRenkiCountMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getSimpleSACountMutator from '../cloak-auth/src/Client/OrvalFetcher';
import deleteScheduledNotificationMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getWorktimeCalendarScheduleMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateWorktimeCalendarScheduleMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createScheduledNotificationMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceSpecByModelAndBrandMutator from '../cloak-auth/src/Client/OrvalFetcher';
import listBrandsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceSpecsByIDsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import searchModelMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceSpecByModelNumberMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceSpecByIDMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateInstancePointMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getInstanceMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getInstancesMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getPublicInstancesMutator from '../cloak-auth/src/Client/OrvalFetcher';
import deleteIntegrationMutator from '../cloak-auth/src/Client/OrvalFetcher';
import listIntegrationsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createIntegrationMutator from '../cloak-auth/src/Client/OrvalFetcher';
import listRenkiIoTAssetsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import hasIoTAssetPermissionsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import listAllOwnedIoTAssetsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getRenkiIoTAssetMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateRenkiIoTAssetMutator from '../cloak-auth/src/Client/OrvalFetcher';
import claimIoTAssetMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createIssueMutator from '../cloak-auth/src/Client/OrvalFetcher';
import redirectNFCMutator from '../cloak-auth/src/Client/OrvalFetcher';
import redirectQRMutator from '../cloak-auth/src/Client/OrvalFetcher';
import claimScreenMutator from '../cloak-auth/src/Client/OrvalFetcher';
import registerScreenMutator from '../cloak-auth/src/Client/OrvalFetcher';
import releaseScreenMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateAreaMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createAreaMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getInstanceDevicesByInstanceIDMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateInstanceDeviceMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateDeviceLayerMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDevicesMutator from '../cloak-auth/src/Client/OrvalFetcher';
import openDoorMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createLayerMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getLayersMutator from '../cloak-auth/src/Client/OrvalFetcher';
import mACScanMutator from '../cloak-auth/src/Client/OrvalFetcher';
import listRenkiTagsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import claimTagMutator from '../cloak-auth/src/Client/OrvalFetcher';
import hasRedirectPermissionsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import listAllOwnedTagsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import addTagLinkMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getTagLinkMutator from '../cloak-auth/src/Client/OrvalFetcher';
import releaseTagMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getRenkiTagMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getRenkiTagTypeMutator from '../cloak-auth/src/Client/OrvalFetcher';
import firstScanMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getTauriUpdateMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getIntegrationMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getTosLatestMutator from '../cloak-auth/src/Client/OrvalFetcher';
import deleteAccountMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getCloakUserMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateCloakUserMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getCloakUserFederatedIdentitiesMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getUserGDPRRequestsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createUserGDPRRequestMutator from '../cloak-auth/src/Client/OrvalFetcher';
import leaveInstanceMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getMSTokenMutator from '../cloak-auth/src/Client/OrvalFetcher';
import logoutAllSessionsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getUserSessionsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getUserActiveInstanceMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceGroupsMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createDeviceGroupMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getUserDeviceGroupsLastSeenMutator from '../cloak-auth/src/Client/OrvalFetcher';
import deleteDeviceGroupMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceGroupByIDMutator from '../cloak-auth/src/Client/OrvalFetcher';
import updateDeviceGroupMutator from '../cloak-auth/src/Client/OrvalFetcher';
import deleteAddressesMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createAddressesMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createAddressesPlainMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getUserDevicegroupIdOnlinedataMutator from '../cloak-auth/src/Client/OrvalFetcher';
import cancelHiddenTimeMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getHiddenTimeMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createHiddenTimeMutator from '../cloak-auth/src/Client/OrvalFetcher';
import listMetadataByUserIDMutator from '../cloak-auth/src/Client/OrvalFetcher';
import createMetadataMutator from '../cloak-auth/src/Client/OrvalFetcher';
import getDeviceInstallationMetadataMutator from '../cloak-auth/src/Client/OrvalFetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * with intertvals 1 hour, 24 hour, 7 day and buckets 5 min, 15 min, 1 hour
 * @summary Get renki count
 */
export const getGetRenkiCountUrl = (params: GetRenkiCountParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/alt/renki/count?${stringifiedParams}` : `/alt/renki/count`;
};

export const getRenkiCount = async (
    params: GetRenkiCountParams,
    options?: RequestInit,
): Promise<AnalyticsGetRenkiCountResponseDTO[]> => {
    return getRenkiCountMutator<AnalyticsGetRenkiCountResponseDTO[]>(getGetRenkiCountUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetRenkiCountKey = (params: GetRenkiCountParams) =>
    [`/alt/renki/count`, ...(params ? [params] : [])] as const;

export type GetRenkiCountQueryResult = NonNullable<Awaited<ReturnType<typeof getRenkiCount>>>;
export type GetRenkiCountQueryError = UtilHttpError;

/**
 * @summary Get renki count
 */
export const useGetRenkiCount = <TError = UtilHttpError>(
    params: GetRenkiCountParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getRenkiCount>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getRenkiCountMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetRenkiCountKey(params) : null));
    const swrFn = () => getRenkiCount(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * with intertvals 1 hour, 24 hour, 7 day and buckets 5 min, 15 min, 1 hour
 * @summary Get simple SA count
 */
export const getGetSimpleSACountUrl = (params: GetSimpleSACountParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/alt/simplecount?${stringifiedParams}` : `/alt/simplecount`;
};

export const getSimpleSACount = async (
    params: GetSimpleSACountParams,
    options?: RequestInit,
): Promise<AnalyticsGetSimpleSACountResponseDTO[]> => {
    return getSimpleSACountMutator<AnalyticsGetSimpleSACountResponseDTO[]>(getGetSimpleSACountUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetSimpleSACountKey = (params: GetSimpleSACountParams) =>
    [`/alt/simplecount`, ...(params ? [params] : [])] as const;

export type GetSimpleSACountQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleSACount>>>;
export type GetSimpleSACountQueryError = UtilHttpError;

/**
 * @summary Get simple SA count
 */
export const useGetSimpleSACount = <TError = UtilHttpError>(
    params: GetSimpleSACountParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getSimpleSACount>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getSimpleSACountMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetSimpleSACountKey(params) : null));
    const swrFn = () => getSimpleSACount(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Deletes the scheduled notification for the authenticated user and specified instance role.
 * @summary Delete Scheduled Notification
 */
export const getDeleteScheduledNotificationUrl = (params: DeleteScheduledNotificationParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/calendar/schedule?${stringifiedParams}` : `/calendar/schedule`;
};

export const deleteScheduledNotification = async (
    params: DeleteScheduledNotificationParams,
    options?: RequestInit,
): Promise<void> => {
    return deleteScheduledNotificationMutator<void>(getDeleteScheduledNotificationUrl(params), {
        ...options,
        method: 'DELETE',
    });
};

export const getDeleteScheduledNotificationMutationFetcher = (
    params: DeleteScheduledNotificationParams,
    options?: SecondParameter<typeof deleteScheduledNotificationMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteScheduledNotification(params, options);
    };
};
export const getDeleteScheduledNotificationMutationKey = (params: DeleteScheduledNotificationParams) =>
    [`/calendar/schedule`, ...(params ? [params] : [])] as const;

export type DeleteScheduledNotificationMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteScheduledNotification>>
>;
export type DeleteScheduledNotificationMutationError = UtilHttpError;

/**
 * @summary Delete Scheduled Notification
 */
export const useDeleteScheduledNotification = <TError = UtilHttpError>(
    params: DeleteScheduledNotificationParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteScheduledNotification>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof deleteScheduledNotification>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteScheduledNotificationMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDeleteScheduledNotificationMutationKey(params);
    const swrFn = getDeleteScheduledNotificationMutationFetcher(params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Retrieves the worktime calendar schedule for the authenticated user and specified instance role.
 * @summary Get Worktime Calendar Schedule
 */
export const getGetWorktimeCalendarScheduleUrl = (params: GetWorktimeCalendarScheduleParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/calendar/schedule?${stringifiedParams}` : `/calendar/schedule`;
};

export const getWorktimeCalendarSchedule = async (
    params: GetWorktimeCalendarScheduleParams,
    options?: RequestInit,
): Promise<CalendarWorkTimeCalendarDTO> => {
    return getWorktimeCalendarScheduleMutator<CalendarWorkTimeCalendarDTO>(getGetWorktimeCalendarScheduleUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetWorktimeCalendarScheduleKey = (params: GetWorktimeCalendarScheduleParams) =>
    [`/calendar/schedule`, ...(params ? [params] : [])] as const;

export type GetWorktimeCalendarScheduleQueryResult = NonNullable<
    Awaited<ReturnType<typeof getWorktimeCalendarSchedule>>
>;
export type GetWorktimeCalendarScheduleQueryError = UtilHttpError;

/**
 * @summary Get Worktime Calendar Schedule
 */
export const useGetWorktimeCalendarSchedule = <TError = UtilHttpError>(
    params: GetWorktimeCalendarScheduleParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getWorktimeCalendarSchedule>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getWorktimeCalendarScheduleMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetWorktimeCalendarScheduleKey(params) : null));
    const swrFn = () => getWorktimeCalendarSchedule(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Updates the worktime calendar schedule for the authenticated user and specified instance role.
 * @summary Update Worktime Calendar Schedule
 */
export const getUpdateWorktimeCalendarScheduleUrl = () => {
    return `/calendar/schedule`;
};

export const updateWorktimeCalendarSchedule = async (
    calendarUpdateWorkTimeCalendarScheduleRequestDTO: CalendarUpdateWorkTimeCalendarScheduleRequestDTO,
    options?: RequestInit,
): Promise<CalendarWorkTimeCalendarDTO> => {
    return updateWorktimeCalendarScheduleMutator<CalendarWorkTimeCalendarDTO>(getUpdateWorktimeCalendarScheduleUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(calendarUpdateWorkTimeCalendarScheduleRequestDTO),
    });
};

export const getUpdateWorktimeCalendarScheduleMutationFetcher = (
    options?: SecondParameter<typeof updateWorktimeCalendarScheduleMutator>,
) => {
    return (_: Key, { arg }: { arg: CalendarUpdateWorkTimeCalendarScheduleRequestDTO }) => {
        return updateWorktimeCalendarSchedule(arg, options);
    };
};
export const getUpdateWorktimeCalendarScheduleMutationKey = () => [`/calendar/schedule`] as const;

export type UpdateWorktimeCalendarScheduleMutationResult = NonNullable<
    Awaited<ReturnType<typeof updateWorktimeCalendarSchedule>>
>;
export type UpdateWorktimeCalendarScheduleMutationError = UtilHttpError;

/**
 * @summary Update Worktime Calendar Schedule
 */
export const useUpdateWorktimeCalendarSchedule = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof updateWorktimeCalendarSchedule>>,
        TError,
        Key,
        CalendarUpdateWorkTimeCalendarScheduleRequestDTO,
        Awaited<ReturnType<typeof updateWorktimeCalendarSchedule>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof updateWorktimeCalendarScheduleMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateWorktimeCalendarScheduleMutationKey();
    const swrFn = getUpdateWorktimeCalendarScheduleMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Creates a new scheduled notification for the authenticated user.
 * @summary Create Scheduled Notification
 */
export const getCreateScheduledNotificationUrl = () => {
    return `/calendar/schedule`;
};

export const createScheduledNotification = async (
    calendarWorktimeCalendarScheduleCreateRequestDTO: CalendarWorktimeCalendarScheduleCreateRequestDTO,
    options?: RequestInit,
): Promise<void> => {
    return createScheduledNotificationMutator<void>(getCreateScheduledNotificationUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(calendarWorktimeCalendarScheduleCreateRequestDTO),
    });
};

export const getCreateScheduledNotificationMutationFetcher = (
    options?: SecondParameter<typeof createScheduledNotificationMutator>,
) => {
    return (_: Key, { arg }: { arg: CalendarWorktimeCalendarScheduleCreateRequestDTO }) => {
        return createScheduledNotification(arg, options);
    };
};
export const getCreateScheduledNotificationMutationKey = () => [`/calendar/schedule`] as const;

export type CreateScheduledNotificationMutationResult = NonNullable<
    Awaited<ReturnType<typeof createScheduledNotification>>
>;
export type CreateScheduledNotificationMutationError = UtilHttpError;

/**
 * @summary Create Scheduled Notification
 */
export const useCreateScheduledNotification = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createScheduledNotification>>,
        TError,
        Key,
        CalendarWorktimeCalendarScheduleCreateRequestDTO,
        Awaited<ReturnType<typeof createScheduledNotification>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createScheduledNotificationMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateScheduledNotificationMutationKey();
    const swrFn = getCreateScheduledNotificationMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device spec by model and brand
 * @summary Get device spec
 */
export const getGetDeviceSpecByModelAndBrandUrl = (params?: GetDeviceSpecByModelAndBrandParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/devicespecs?${stringifiedParams}` : `/devicespecs`;
};

export const getDeviceSpecByModelAndBrand = async (
    params?: GetDeviceSpecByModelAndBrandParams,
    options?: RequestInit,
): Promise<DevicespecsDTO> => {
    return getDeviceSpecByModelAndBrandMutator<DevicespecsDTO>(getGetDeviceSpecByModelAndBrandUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetDeviceSpecByModelAndBrandKey = (params?: GetDeviceSpecByModelAndBrandParams) =>
    [`/devicespecs`, ...(params ? [params] : [])] as const;

export type GetDeviceSpecByModelAndBrandQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDeviceSpecByModelAndBrand>>
>;
export type GetDeviceSpecByModelAndBrandQueryError = UtilHttpError;

/**
 * @summary Get device spec
 */
export const useGetDeviceSpecByModelAndBrand = <TError = UtilHttpError>(
    params?: GetDeviceSpecByModelAndBrandParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceSpecByModelAndBrand>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceSpecByModelAndBrandMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceSpecByModelAndBrandKey(params) : null));
    const swrFn = () => getDeviceSpecByModelAndBrand(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get all brands
 * @summary List all brands
 */
export const getListBrandsUrl = () => {
    return `/devicespecs/brand`;
};

export const listBrands = async (options?: RequestInit): Promise<DevicespecsListBrandsResponseDTO> => {
    return listBrandsMutator<DevicespecsListBrandsResponseDTO>(getListBrandsUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getListBrandsKey = () => [`/devicespecs/brand`] as const;

export type ListBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof listBrands>>>;
export type ListBrandsQueryError = unknown;

/**
 * @summary List all brands
 */
export const useListBrands = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listBrands>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof listBrandsMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListBrandsKey() : null));
    const swrFn = () => listBrands(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device specs by IDs
 * @summary Get device specs by IDs
 */
export const getGetDeviceSpecsByIDsUrl = (ids: string) => {
    return `/devicespecs/bulk/${ids}`;
};

export const getDeviceSpecsByIDs = async (ids: string, options?: RequestInit): Promise<DevicespecsDTO[]> => {
    return getDeviceSpecsByIDsMutator<DevicespecsDTO[]>(getGetDeviceSpecsByIDsUrl(ids), {
        ...options,
        method: 'GET',
    });
};

export const getGetDeviceSpecsByIDsKey = (ids: string) => [`/devicespecs/bulk/${ids}`] as const;

export type GetDeviceSpecsByIDsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceSpecsByIDs>>>;
export type GetDeviceSpecsByIDsQueryError = UtilHttpError;

/**
 * @summary Get device specs by IDs
 */
export const useGetDeviceSpecsByIDs = <TError = UtilHttpError>(
    ids: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceSpecsByIDs>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceSpecsByIDsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!ids;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceSpecsByIDsKey(ids) : null));
    const swrFn = () => getDeviceSpecsByIDs(ids, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Search for a model, list all models by brand by omitting model parameter
 * @summary Search for a model
 */
export const getSearchModelUrl = (params: SearchModelParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/devicespecs/model?${stringifiedParams}` : `/devicespecs/model`;
};

export const searchModel = async (
    params: SearchModelParams,
    options?: RequestInit,
): Promise<DevicespecsSearchModelResponseDTO> => {
    return searchModelMutator<DevicespecsSearchModelResponseDTO>(getSearchModelUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getSearchModelKey = (params: SearchModelParams) =>
    [`/devicespecs/model`, ...(params ? [params] : [])] as const;

export type SearchModelQueryResult = NonNullable<Awaited<ReturnType<typeof searchModel>>>;
export type SearchModelQueryError = UtilHttpError;

/**
 * @summary Search for a model
 */
export const useSearchModel = <TError = UtilHttpError>(
    params: SearchModelParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof searchModel>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof searchModelMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getSearchModelKey(params) : null));
    const swrFn = () => searchModel(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device spec by Model Number
 * @summary Get device spec by Model Number
 */
export const getGetDeviceSpecByModelNumberUrl = (modelnumber: string) => {
    return `/devicespecs/modelnumber/${modelnumber}`;
};

export const getDeviceSpecByModelNumber = async (
    modelnumber: string,
    options?: RequestInit,
): Promise<DevicespecsDTO> => {
    return getDeviceSpecByModelNumberMutator<DevicespecsDTO>(getGetDeviceSpecByModelNumberUrl(modelnumber), {
        ...options,
        method: 'GET',
    });
};

export const getGetDeviceSpecByModelNumberKey = (modelnumber: string) =>
    [`/devicespecs/modelnumber/${modelnumber}`] as const;

export type GetDeviceSpecByModelNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceSpecByModelNumber>>>;
export type GetDeviceSpecByModelNumberQueryError = UtilHttpError;

/**
 * @summary Get device spec by Model Number
 */
export const useGetDeviceSpecByModelNumber = <TError = UtilHttpError>(
    modelnumber: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceSpecByModelNumber>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceSpecByModelNumberMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!modelnumber;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceSpecByModelNumberKey(modelnumber) : null));
    const swrFn = () => getDeviceSpecByModelNumber(modelnumber, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device spec by ID
 * @summary Get device spec by ID
 */
export const getGetDeviceSpecByIDUrl = (id: number) => {
    return `/devicespecs/${id}`;
};

export const getDeviceSpecByID = async (id: number, options?: RequestInit): Promise<DevicespecsDTO> => {
    return getDeviceSpecByIDMutator<DevicespecsDTO>(getGetDeviceSpecByIDUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getGetDeviceSpecByIDKey = (id: number) => [`/devicespecs/${id}`] as const;

export type GetDeviceSpecByIDQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceSpecByID>>>;
export type GetDeviceSpecByIDQueryError = UtilHttpError;

/**
 * @summary Get device spec by ID
 */
export const useGetDeviceSpecByID = <TError = UtilHttpError>(
    id: number,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceSpecByID>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceSpecByIDMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceSpecByIDKey(id) : null));
    const swrFn = () => getDeviceSpecByID(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Update point by instance ID
 * @summary Update point by instance ID
 */
export const getUpdateInstancePointUrl = () => {
    return `/instance/point`;
};

export const updateInstancePoint = async (
    instanceUpdateInstancePointRequestDTO: InstanceUpdateInstancePointRequestDTO,
    options?: RequestInit,
): Promise<void> => {
    return updateInstancePointMutator<void>(getUpdateInstancePointUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(instanceUpdateInstancePointRequestDTO),
    });
};

export const getUpdateInstancePointMutationFetcher = (options?: SecondParameter<typeof updateInstancePointMutator>) => {
    return (_: Key, { arg }: { arg: InstanceUpdateInstancePointRequestDTO }) => {
        return updateInstancePoint(arg, options);
    };
};
export const getUpdateInstancePointMutationKey = () => [`/instance/point`] as const;

export type UpdateInstancePointMutationResult = NonNullable<Awaited<ReturnType<typeof updateInstancePoint>>>;
export type UpdateInstancePointMutationError = UtilHttpError;

/**
 * @summary Update point by instance ID
 */
export const useUpdateInstancePoint = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof updateInstancePoint>>,
        TError,
        Key,
        InstanceUpdateInstancePointRequestDTO,
        Awaited<ReturnType<typeof updateInstancePoint>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof updateInstancePointMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateInstancePointMutationKey();
    const swrFn = getUpdateInstancePointMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get instance by ID
 * @summary Get instance by ID
 */
export const getGetInstanceUrl = (id: string) => {
    return `/instance/${id}`;
};

export const getInstance = async (id: string, options?: RequestInit): Promise<InstanceDTO> => {
    return getInstanceMutator<InstanceDTO>(getGetInstanceUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getGetInstanceKey = (id: string) => [`/instance/${id}`] as const;

export type GetInstanceQueryResult = NonNullable<Awaited<ReturnType<typeof getInstance>>>;
export type GetInstanceQueryError = UtilHttpError;

/**
 * @summary Get instance by ID
 */
export const useGetInstance = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getInstance>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getInstanceMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetInstanceKey(id) : null));
    const swrFn = () => getInstance(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get instances by roles
 * @summary Get instances by roles
 */
export const getGetInstancesUrl = () => {
    return `/instances`;
};

export const getInstances = async (options?: RequestInit): Promise<InstanceDTO[]> => {
    return getInstancesMutator<InstanceDTO[]>(getGetInstancesUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetInstancesKey = () => [`/instances`] as const;

export type GetInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof getInstances>>>;
export type GetInstancesQueryError = UtilHttpError;

/**
 * @summary Get instances by roles
 */
export const useGetInstances = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getInstances>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof getInstancesMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetInstancesKey() : null));
    const swrFn = () => getInstances(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get public instances
 * @summary Get public instances
 */
export const getGetPublicInstancesUrl = () => {
    return `/instances/public`;
};

export const getPublicInstances = async (options?: RequestInit): Promise<InstancePublicInstance[]> => {
    return getPublicInstancesMutator<InstancePublicInstance[]>(getGetPublicInstancesUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetPublicInstancesKey = () => [`/instances/public`] as const;

export type GetPublicInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicInstances>>>;
export type GetPublicInstancesQueryError = UtilHttpError;

/**
 * @summary Get public instances
 */
export const useGetPublicInstances = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getPublicInstances>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof getPublicInstancesMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetPublicInstancesKey() : null));
    const swrFn = () => getPublicInstances(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete an integration and its secret
 * @summary Delete integration
 */
export const getDeleteIntegrationUrl = (params: DeleteIntegrationParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/integrations?${stringifiedParams}` : `/integrations`;
};

export const deleteIntegration = async (params: DeleteIntegrationParams, options?: RequestInit): Promise<void> => {
    return deleteIntegrationMutator<void>(getDeleteIntegrationUrl(params), {
        ...options,
        method: 'DELETE',
    });
};

export const getDeleteIntegrationMutationFetcher = (
    params: DeleteIntegrationParams,
    options?: SecondParameter<typeof deleteIntegrationMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteIntegration(params, options);
    };
};
export const getDeleteIntegrationMutationKey = (params: DeleteIntegrationParams) =>
    [`/integrations`, ...(params ? [params] : [])] as const;

export type DeleteIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegration>>>;
export type DeleteIntegrationMutationError = UtilHttpError;

/**
 * @summary Delete integration
 */
export const useDeleteIntegration = <TError = UtilHttpError>(
    params: DeleteIntegrationParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteIntegration>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof deleteIntegration>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteIntegrationMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDeleteIntegrationMutationKey(params);
    const swrFn = getDeleteIntegrationMutationFetcher(params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * List all integrations for a tenant role
 * @summary List integrations
 */
export const getListIntegrationsUrl = (params: ListIntegrationsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/integrations?${stringifiedParams}` : `/integrations`;
};

export const listIntegrations = async (
    params: ListIntegrationsParams,
    options?: RequestInit,
): Promise<IntegrationsListIntegrationsDTO> => {
    return listIntegrationsMutator<IntegrationsListIntegrationsDTO>(getListIntegrationsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getListIntegrationsKey = (params: ListIntegrationsParams) =>
    [`/integrations`, ...(params ? [params] : [])] as const;

export type ListIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrations>>>;
export type ListIntegrationsQueryError = UtilHttpError;

/**
 * @summary List integrations
 */
export const useListIntegrations = <TError = UtilHttpError>(
    params: ListIntegrationsParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof listIntegrations>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof listIntegrationsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListIntegrationsKey(params) : null));
    const swrFn = () => listIntegrations(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create a new integration for a tenant role
 * @summary Create integration
 */
export const getCreateIntegrationUrl = () => {
    return `/integrations`;
};

export const createIntegration = async (
    integrationsCreateIntegrationRequestDTO: IntegrationsCreateIntegrationRequestDTO,
    options?: RequestInit,
): Promise<IntegrationsIntegrationDTO> => {
    return createIntegrationMutator<IntegrationsIntegrationDTO>(getCreateIntegrationUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(integrationsCreateIntegrationRequestDTO),
    });
};

export const getCreateIntegrationMutationFetcher = (options?: SecondParameter<typeof createIntegrationMutator>) => {
    return (_: Key, { arg }: { arg: IntegrationsCreateIntegrationRequestDTO }) => {
        return createIntegration(arg, options);
    };
};
export const getCreateIntegrationMutationKey = () => [`/integrations`] as const;

export type CreateIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof createIntegration>>>;
export type CreateIntegrationMutationError = UtilHttpError;

/**
 * @summary Create integration
 */
export const useCreateIntegration = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createIntegration>>,
        TError,
        Key,
        IntegrationsCreateIntegrationRequestDTO,
        Awaited<ReturnType<typeof createIntegration>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createIntegrationMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateIntegrationMutationKey();
    const swrFn = getCreateIntegrationMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * List IoT assets filtered by one ownership dimension (company_id | group_id | user_id) within an instance.
 * @summary List accessible IoT assets
 */
export const getListRenkiIoTAssetsUrl = (params: ListRenkiIoTAssetsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/iotasset?${stringifiedParams}` : `/iotasset`;
};

export const listRenkiIoTAssets = async (
    params: ListRenkiIoTAssetsParams,
    options?: RequestInit,
): Promise<IotassetListRenkiIoTAssetsResponseDTO> => {
    return listRenkiIoTAssetsMutator<IotassetListRenkiIoTAssetsResponseDTO>(getListRenkiIoTAssetsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getListRenkiIoTAssetsKey = (params: ListRenkiIoTAssetsParams) =>
    [`/iotasset`, ...(params ? [params] : [])] as const;

export type ListRenkiIoTAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof listRenkiIoTAssets>>>;
export type ListRenkiIoTAssetsQueryError = unknown;

/**
 * @summary List accessible IoT assets
 */
export const useListRenkiIoTAssets = <TError = unknown>(
    params: ListRenkiIoTAssetsParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof listRenkiIoTAssets>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof listRenkiIoTAssetsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListRenkiIoTAssetsKey(params) : null));
    const swrFn = () => listRenkiIoTAssets(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Returns permission true if caller can edit informative fields or claim (superuser).
 * @summary Check if caller can modify IoT asset
 */
export const getHasIoTAssetPermissionsUrl = (id: string) => {
    return `/iotasset/haspermissions/${id}`;
};

export const hasIoTAssetPermissions = async (
    id: string,
    options?: RequestInit,
): Promise<IotassetHasIoTAssetPermissionsResponseDTO> => {
    return hasIoTAssetPermissionsMutator<IotassetHasIoTAssetPermissionsResponseDTO>(getHasIoTAssetPermissionsUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getHasIoTAssetPermissionsKey = (id: string) => [`/iotasset/haspermissions/${id}`] as const;

export type HasIoTAssetPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof hasIoTAssetPermissions>>>;
export type HasIoTAssetPermissionsQueryError = unknown;

/**
 * @summary Check if caller can modify IoT asset
 */
export const useHasIoTAssetPermissions = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof hasIoTAssetPermissions>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof hasIoTAssetPermissionsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getHasIoTAssetPermissionsKey(id) : null));
    const swrFn = () => hasIoTAssetPermissions(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Aggregates ownership paths; superuser sees also unassigned assets.
 * @summary List all IoT assets owned by caller (direct or via company/group) within an instance.
 */
export const getListAllOwnedIoTAssetsUrl = (params: ListAllOwnedIoTAssetsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/iotasset/owned?${stringifiedParams}` : `/iotasset/owned`;
};

export const listAllOwnedIoTAssets = async (
    params: ListAllOwnedIoTAssetsParams,
    options?: RequestInit,
): Promise<IotassetListRenkiIoTAssetsResponseDTO> => {
    return listAllOwnedIoTAssetsMutator<IotassetListRenkiIoTAssetsResponseDTO>(getListAllOwnedIoTAssetsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getListAllOwnedIoTAssetsKey = (params: ListAllOwnedIoTAssetsParams) =>
    [`/iotasset/owned`, ...(params ? [params] : [])] as const;

export type ListAllOwnedIoTAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllOwnedIoTAssets>>>;
export type ListAllOwnedIoTAssetsQueryError = unknown;

/**
 * @summary List all IoT assets owned by caller (direct or via company/group) within an instance.
 */
export const useListAllOwnedIoTAssets = <TError = unknown>(
    params: ListAllOwnedIoTAssetsParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof listAllOwnedIoTAssets>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof listAllOwnedIoTAssetsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListAllOwnedIoTAssetsKey(params) : null));
    const swrFn = () => listAllOwnedIoTAssets(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Returns a single IoT asset if caller has ownership permissions or is instance superuser.
 * @summary Get IoT asset (permission aware)
 */
export const getGetRenkiIoTAssetUrl = (id: string) => {
    return `/iotasset/${id}`;
};

export const getRenkiIoTAsset = async (id: string, options?: RequestInit): Promise<IotassetRenkiIoTAssetDTO> => {
    return getRenkiIoTAssetMutator<IotassetRenkiIoTAssetDTO>(getGetRenkiIoTAssetUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getGetRenkiIoTAssetKey = (id: string) => [`/iotasset/${id}`] as const;

export type GetRenkiIoTAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getRenkiIoTAsset>>>;
export type GetRenkiIoTAssetQueryError = unknown;

/**
 * @summary Get IoT asset (permission aware)
 */
export const useGetRenkiIoTAsset = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getRenkiIoTAsset>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getRenkiIoTAssetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetRenkiIoTAssetKey(id) : null));
    const swrFn = () => getRenkiIoTAsset(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Allows editing non-ownership fields only if caller has access permissions.
 * @summary Update informative fields of IoT asset (end-user)
 */
export const getUpdateRenkiIoTAssetUrl = (id: string) => {
    return `/iotasset/${id}`;
};

export const updateRenkiIoTAsset = async (
    id: string,
    iotassetUpdateIoTAssetUserFieldsDTO: IotassetUpdateIoTAssetUserFieldsDTO,
    options?: RequestInit,
): Promise<IotassetIoTAssetDTO> => {
    return updateRenkiIoTAssetMutator<IotassetIoTAssetDTO>(getUpdateRenkiIoTAssetUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(iotassetUpdateIoTAssetUserFieldsDTO),
    });
};

export const getUpdateRenkiIoTAssetMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof updateRenkiIoTAssetMutator>,
) => {
    return (_: Key, { arg }: { arg: IotassetUpdateIoTAssetUserFieldsDTO }) => {
        return updateRenkiIoTAsset(id, arg, options);
    };
};
export const getUpdateRenkiIoTAssetMutationKey = (id: string) => [`/iotasset/${id}`] as const;

export type UpdateRenkiIoTAssetMutationResult = NonNullable<Awaited<ReturnType<typeof updateRenkiIoTAsset>>>;
export type UpdateRenkiIoTAssetMutationError = unknown;

/**
 * @summary Update informative fields of IoT asset (end-user)
 */
export const useUpdateRenkiIoTAsset = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof updateRenkiIoTAsset>>,
            TError,
            Key,
            IotassetUpdateIoTAssetUserFieldsDTO,
            Awaited<ReturnType<typeof updateRenkiIoTAsset>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof updateRenkiIoTAssetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateRenkiIoTAssetMutationKey(id);
    const swrFn = getUpdateRenkiIoTAssetMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Superuser assigns exactly one ownership dimension (company_id | group_id | user_ids | instance_id). Any previous ownership is overwritten to preserve exclusivity.
 * @summary Claim / (re)assign ownership to IoT asset (superuser only)
 */
export const getClaimIoTAssetUrl = (id: string) => {
    return `/iotasset/${id}/claim`;
};

export const claimIoTAsset = async (
    id: string,
    iotassetClaimIoTAssetDTO: IotassetClaimIoTAssetDTO,
    options?: RequestInit,
): Promise<void> => {
    return claimIoTAssetMutator<void>(getClaimIoTAssetUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(iotassetClaimIoTAssetDTO),
    });
};

export const getClaimIoTAssetMutationFetcher = (id: string, options?: SecondParameter<typeof claimIoTAssetMutator>) => {
    return (_: Key, { arg }: { arg: IotassetClaimIoTAssetDTO }) => {
        return claimIoTAsset(id, arg, options);
    };
};
export const getClaimIoTAssetMutationKey = (id: string) => [`/iotasset/${id}/claim`] as const;

export type ClaimIoTAssetMutationResult = NonNullable<Awaited<ReturnType<typeof claimIoTAsset>>>;
export type ClaimIoTAssetMutationError = unknown;

/**
 * @summary Claim / (re)assign ownership to IoT asset (superuser only)
 */
export const useClaimIoTAsset = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof claimIoTAsset>>,
            TError,
            Key,
            IotassetClaimIoTAssetDTO,
            Awaited<ReturnType<typeof claimIoTAsset>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof claimIoTAssetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getClaimIoTAssetMutationKey(id);
    const swrFn = getClaimIoTAssetMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create a new issue
 * @summary Create a new issue
 */
export const getCreateIssueUrl = () => {
    return `/issue`;
};

export const createIssue = async (issueCreateDTO: IssueCreateDTO, options?: RequestInit): Promise<void> => {
    return createIssueMutator<void>(getCreateIssueUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(issueCreateDTO),
    });
};

export const getCreateIssueMutationFetcher = (options?: SecondParameter<typeof createIssueMutator>) => {
    return (_: Key, { arg }: { arg: IssueCreateDTO }) => {
        return createIssue(arg, options);
    };
};
export const getCreateIssueMutationKey = () => [`/issue`] as const;

export type CreateIssueMutationResult = NonNullable<Awaited<ReturnType<typeof createIssue>>>;
export type CreateIssueMutationError = UtilHttpError;

/**
 * @summary Create a new issue
 */
export const useCreateIssue = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createIssue>>,
        TError,
        Key,
        IssueCreateDTO,
        Awaited<ReturnType<typeof createIssue>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createIssueMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateIssueMutationKey();
    const swrFn = getCreateIssueMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Redirect NFC
 * @summary Redirect NFC
 */
export const getRedirectNFCUrl = (serial: string) => {
    return `/nfc/${serial}`;
};

export const redirectNFC = async (serial: string, options?: RequestInit): Promise<unknown> => {
    return redirectNFCMutator<unknown>(getRedirectNFCUrl(serial), {
        ...options,
        method: 'GET',
    });
};

export const getRedirectNFCKey = (serial: string) => [`/nfc/${serial}`] as const;

export type RedirectNFCQueryResult = NonNullable<Awaited<ReturnType<typeof redirectNFC>>>;
export type RedirectNFCQueryError = void;

/**
 * @summary Redirect NFC
 */
export const useRedirectNFC = <TError = void>(
    serial: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof redirectNFC>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof redirectNFCMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!serial;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getRedirectNFCKey(serial) : null));
    const swrFn = () => redirectNFC(serial, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Redirect QR
 * @summary Redirect QR
 */
export const getRedirectQRUrl = (serial: string) => {
    return `/qr/${serial}`;
};

export const redirectQR = async (serial: string, options?: RequestInit): Promise<unknown> => {
    return redirectQRMutator<unknown>(getRedirectQRUrl(serial), {
        ...options,
        method: 'GET',
    });
};

export const getRedirectQRKey = (serial: string) => [`/qr/${serial}`] as const;

export type RedirectQRQueryResult = NonNullable<Awaited<ReturnType<typeof redirectQR>>>;
export type RedirectQRQueryError = void;

/**
 * @summary Redirect QR
 */
export const useRedirectQR = <TError = void>(
    serial: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof redirectQR>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof redirectQRMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!serial;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getRedirectQRKey(serial) : null));
    const swrFn = () => redirectQR(serial, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Claim a screen with installation ID before installing it in instance
 * @summary Claim a screen
 */
export const getClaimScreenUrl = () => {
    return `/screen/claim`;
};

export const claimScreen = async (screenClaim: ScreenClaim, options?: RequestInit): Promise<void> => {
    return claimScreenMutator<void>(getClaimScreenUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(screenClaim),
    });
};

export const getClaimScreenMutationFetcher = (options?: SecondParameter<typeof claimScreenMutator>) => {
    return (_: Key, { arg }: { arg: ScreenClaim }) => {
        return claimScreen(arg, options);
    };
};
export const getClaimScreenMutationKey = () => [`/screen/claim`] as const;

export type ClaimScreenMutationResult = NonNullable<Awaited<ReturnType<typeof claimScreen>>>;
export type ClaimScreenMutationError = UtilHttpError;

/**
 * @summary Claim a screen
 */
export const useClaimScreen = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof claimScreen>>,
        TError,
        Key,
        ScreenClaim,
        Awaited<ReturnType<typeof claimScreen>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof claimScreenMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getClaimScreenMutationKey();
    const swrFn = getClaimScreenMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Register a screen with installation ID
 * @summary Register a screen
 */
export const getRegisterScreenUrl = () => {
    return `/screen/register`;
};

export const registerScreen = async (
    screenRegistration: ScreenRegistration,
    options?: RequestInit,
): Promise<ScreenState> => {
    return registerScreenMutator<ScreenState>(getRegisterScreenUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(screenRegistration),
    });
};

export const getRegisterScreenMutationFetcher = (options?: SecondParameter<typeof registerScreenMutator>) => {
    return (_: Key, { arg }: { arg: ScreenRegistration }) => {
        return registerScreen(arg, options);
    };
};
export const getRegisterScreenMutationKey = () => [`/screen/register`] as const;

export type RegisterScreenMutationResult = NonNullable<Awaited<ReturnType<typeof registerScreen>>>;
export type RegisterScreenMutationError = UtilHttpError;

/**
 * @summary Register a screen
 */
export const useRegisterScreen = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof registerScreen>>,
        TError,
        Key,
        ScreenRegistration,
        Awaited<ReturnType<typeof registerScreen>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof registerScreenMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getRegisterScreenMutationKey();
    const swrFn = getRegisterScreenMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Release a screen from instance
 * @summary Release a screen
 */
export const getReleaseScreenUrl = () => {
    return `/screen/release`;
};

export const releaseScreen = async (
    screenReleaseScreenRequestDTO: ScreenReleaseScreenRequestDTO,
    options?: RequestInit,
): Promise<void> => {
    return releaseScreenMutator<void>(getReleaseScreenUrl(), {
        ...options,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(screenReleaseScreenRequestDTO),
    });
};

export const getReleaseScreenMutationFetcher = (options?: SecondParameter<typeof releaseScreenMutator>) => {
    return (_: Key, { arg }: { arg: ScreenReleaseScreenRequestDTO }) => {
        return releaseScreen(arg, options);
    };
};
export const getReleaseScreenMutationKey = () => [`/screen/release`] as const;

export type ReleaseScreenMutationResult = NonNullable<Awaited<ReturnType<typeof releaseScreen>>>;
export type ReleaseScreenMutationError = UtilHttpError;

/**
 * @summary Release a screen
 */
export const useReleaseScreen = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof releaseScreen>>,
        TError,
        Key,
        ScreenReleaseScreenRequestDTO,
        Awaited<ReturnType<typeof releaseScreen>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof releaseScreenMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getReleaseScreenMutationKey();
    const swrFn = getReleaseScreenMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Update area for device in a specific layer
 * @summary Update area
 */
export const getUpdateAreaUrl = () => {
    return `/sensor/area`;
};

export const updateArea = async (
    sensorUpdateAreaRequestDTO: SensorUpdateAreaRequestDTO,
    options?: RequestInit,
): Promise<SensorAreaDTO> => {
    return updateAreaMutator<SensorAreaDTO>(getUpdateAreaUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sensorUpdateAreaRequestDTO),
    });
};

export const getUpdateAreaMutationFetcher = (options?: SecondParameter<typeof updateAreaMutator>) => {
    return (_: Key, { arg }: { arg: SensorUpdateAreaRequestDTO }) => {
        return updateArea(arg, options);
    };
};
export const getUpdateAreaMutationKey = () => [`/sensor/area`] as const;

export type UpdateAreaMutationResult = NonNullable<Awaited<ReturnType<typeof updateArea>>>;
export type UpdateAreaMutationError = UtilHttpError;

/**
 * @summary Update area
 */
export const useUpdateArea = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof updateArea>>,
        TError,
        Key,
        SensorUpdateAreaRequestDTO,
        Awaited<ReturnType<typeof updateArea>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof updateAreaMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateAreaMutationKey();
    const swrFn = getUpdateAreaMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create area for device in a specific layer
 * @summary Create area for device
 */
export const getCreateAreaUrl = () => {
    return `/sensor/area`;
};

export const createArea = async (
    sensorCreateAreaRequestDTO: SensorCreateAreaRequestDTO,
    options?: RequestInit,
): Promise<SensorCreateAreaResponseDTO> => {
    return createAreaMutator<SensorCreateAreaResponseDTO>(getCreateAreaUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sensorCreateAreaRequestDTO),
    });
};

export const getCreateAreaMutationFetcher = (options?: SecondParameter<typeof createAreaMutator>) => {
    return (_: Key, { arg }: { arg: SensorCreateAreaRequestDTO }) => {
        return createArea(arg, options);
    };
};
export const getCreateAreaMutationKey = () => [`/sensor/area`] as const;

export type CreateAreaMutationResult = NonNullable<Awaited<ReturnType<typeof createArea>>>;
export type CreateAreaMutationError = UtilHttpError;

/**
 * @summary Create area for device
 */
export const useCreateArea = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createArea>>,
        TError,
        Key,
        SensorCreateAreaRequestDTO,
        Awaited<ReturnType<typeof createArea>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createAreaMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateAreaMutationKey();
    const swrFn = getCreateAreaMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get devices by instance ID
 * @summary Get devices by instance ID
 */
export const getGetInstanceDevicesByInstanceIDUrl = (params: GetInstanceDevicesByInstanceIDParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/sensor/device?${stringifiedParams}` : `/sensor/device`;
};

export const getInstanceDevicesByInstanceID = async (
    params: GetInstanceDevicesByInstanceIDParams,
    options?: RequestInit,
): Promise<SensorInstanceDeviceResponseDTO> => {
    return getInstanceDevicesByInstanceIDMutator<SensorInstanceDeviceResponseDTO>(
        getGetInstanceDevicesByInstanceIDUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetInstanceDevicesByInstanceIDKey = (params: GetInstanceDevicesByInstanceIDParams) =>
    [`/sensor/device`, ...(params ? [params] : [])] as const;

export type GetInstanceDevicesByInstanceIDQueryResult = NonNullable<
    Awaited<ReturnType<typeof getInstanceDevicesByInstanceID>>
>;
export type GetInstanceDevicesByInstanceIDQueryError = UtilHttpError;

/**
 * @summary Get devices by instance ID
 */
export const useGetInstanceDevicesByInstanceID = <TError = UtilHttpError>(
    params: GetInstanceDevicesByInstanceIDParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getInstanceDevicesByInstanceID>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getInstanceDevicesByInstanceIDMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetInstanceDevicesByInstanceIDKey(params) : null));
    const swrFn = () => getInstanceDevicesByInstanceID(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Update device by instance ID
 * @summary Update device by instance ID
 */
export const getUpdateInstanceDeviceUrl = () => {
    return `/sensor/device`;
};

export const updateInstanceDevice = async (
    sensorUpdateInstanceDeviceRequestDTO: SensorUpdateInstanceDeviceRequestDTO,
    options?: RequestInit,
): Promise<void> => {
    return updateInstanceDeviceMutator<void>(getUpdateInstanceDeviceUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sensorUpdateInstanceDeviceRequestDTO),
    });
};

export const getUpdateInstanceDeviceMutationFetcher = (
    options?: SecondParameter<typeof updateInstanceDeviceMutator>,
) => {
    return (_: Key, { arg }: { arg: SensorUpdateInstanceDeviceRequestDTO }) => {
        return updateInstanceDevice(arg, options);
    };
};
export const getUpdateInstanceDeviceMutationKey = () => [`/sensor/device`] as const;

export type UpdateInstanceDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof updateInstanceDevice>>>;
export type UpdateInstanceDeviceMutationError = UtilHttpError;

/**
 * @summary Update device by instance ID
 */
export const useUpdateInstanceDevice = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof updateInstanceDevice>>,
        TError,
        Key,
        SensorUpdateInstanceDeviceRequestDTO,
        Awaited<ReturnType<typeof updateInstanceDevice>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof updateInstanceDeviceMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateInstanceDeviceMutationKey();
    const swrFn = getUpdateInstanceDeviceMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Update device layer
 * @summary Update device layer
 */
export const getUpdateDeviceLayerUrl = () => {
    return `/sensor/device/layer`;
};

export const updateDeviceLayer = async (
    sensorUpdateDeviceLayerRequestDTO: SensorUpdateDeviceLayerRequestDTO,
    options?: RequestInit,
): Promise<SensorUpdateDeviceLayerResponseDTO> => {
    return updateDeviceLayerMutator<SensorUpdateDeviceLayerResponseDTO>(getUpdateDeviceLayerUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sensorUpdateDeviceLayerRequestDTO),
    });
};

export const getUpdateDeviceLayerMutationFetcher = (options?: SecondParameter<typeof updateDeviceLayerMutator>) => {
    return (_: Key, { arg }: { arg: SensorUpdateDeviceLayerRequestDTO }) => {
        return updateDeviceLayer(arg, options);
    };
};
export const getUpdateDeviceLayerMutationKey = () => [`/sensor/device/layer`] as const;

export type UpdateDeviceLayerMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceLayer>>>;
export type UpdateDeviceLayerMutationError = UtilHttpError;

/**
 * @summary Update device layer
 */
export const useUpdateDeviceLayer = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof updateDeviceLayer>>,
        TError,
        Key,
        SensorUpdateDeviceLayerRequestDTO,
        Awaited<ReturnType<typeof updateDeviceLayer>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof updateDeviceLayerMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateDeviceLayerMutationKey();
    const swrFn = getUpdateDeviceLayerMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device by serial and instance ID
 * @summary Get device by serial
 */
export const getGetDeviceUrl = (serial: string, params: GetDeviceParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/sensor/device/${serial}?${stringifiedParams}` : `/sensor/device/${serial}`;
};

export const getDevice = async (
    serial: string,
    params: GetDeviceParams,
    options?: RequestInit,
): Promise<SensorGetDeviceResponseDTO> => {
    return getDeviceMutator<SensorGetDeviceResponseDTO>(getGetDeviceUrl(serial, params), {
        ...options,
        method: 'GET',
    });
};

export const getGetDeviceKey = (serial: string, params: GetDeviceParams) =>
    [`/sensor/device/${serial}`, ...(params ? [params] : [])] as const;

export type GetDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getDevice>>>;
export type GetDeviceQueryError = UtilHttpError;

/**
 * @summary Get device by serial
 */
export const useGetDevice = <TError = UtilHttpError>(
    serial: string,
    params: GetDeviceParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDevice>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getDeviceMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!serial;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceKey(serial, params) : null));
    const swrFn = () => getDevice(serial, params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get devices by instance ID
 * @summary Get devices by instance ID
 */
export const getGetDevicesUrl = (params: GetDevicesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/sensor/devices?${stringifiedParams}` : `/sensor/devices`;
};

export const getDevices = async (
    params: GetDevicesParams,
    options?: RequestInit,
): Promise<SensorGetDeviceResponseDTO[]> => {
    return getDevicesMutator<SensorGetDeviceResponseDTO[]>(getGetDevicesUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetDevicesKey = (params: GetDevicesParams) => [`/sensor/devices`, ...(params ? [params] : [])] as const;

export type GetDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof getDevices>>>;
export type GetDevicesQueryError = UtilHttpError;

/**
 * @summary Get devices by instance ID
 */
export const useGetDevices = <TError = UtilHttpError>(
    params: GetDevicesParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDevices>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getDevicesMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDevicesKey(params) : null));
    const swrFn = () => getDevices(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Open door by device serial
 * @summary Open door
 */
export const getOpenDoorUrl = () => {
    return `/sensor/door`;
};

export const openDoor = async (options?: RequestInit): Promise<void> => {
    return openDoorMutator<void>(getOpenDoorUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getOpenDoorMutationFetcher = (options?: SecondParameter<typeof openDoorMutator>) => {
    return (_: Key, __: { arg: Arguments }) => {
        return openDoor(options);
    };
};
export const getOpenDoorMutationKey = () => [`/sensor/door`] as const;

export type OpenDoorMutationResult = NonNullable<Awaited<ReturnType<typeof openDoor>>>;
export type OpenDoorMutationError = UtilHttpError;

/**
 * @summary Open door
 */
export const useOpenDoor = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof openDoor>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof openDoor>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof openDoorMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getOpenDoorMutationKey();
    const swrFn = getOpenDoorMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create a new layer for a specific instance role
 * @summary Create layer
 */
export const getCreateLayerUrl = () => {
    return `/sensor/layer`;
};

export const createLayer = async (
    sensorCreateLayerRequestDTO: SensorCreateLayerRequestDTO,
    options?: RequestInit,
): Promise<SensorLayerDTO> => {
    return createLayerMutator<SensorLayerDTO>(getCreateLayerUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sensorCreateLayerRequestDTO),
    });
};

export const getCreateLayerMutationFetcher = (options?: SecondParameter<typeof createLayerMutator>) => {
    return (_: Key, { arg }: { arg: SensorCreateLayerRequestDTO }) => {
        return createLayer(arg, options);
    };
};
export const getCreateLayerMutationKey = () => [`/sensor/layer`] as const;

export type CreateLayerMutationResult = NonNullable<Awaited<ReturnType<typeof createLayer>>>;
export type CreateLayerMutationError = UtilHttpError;

/**
 * @summary Create layer
 */
export const useCreateLayer = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createLayer>>,
        TError,
        Key,
        SensorCreateLayerRequestDTO,
        Awaited<ReturnType<typeof createLayer>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createLayerMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateLayerMutationKey();
    const swrFn = getCreateLayerMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get layers by instance role
 * @summary Get layers by instance role
 */
export const getGetLayersUrl = (params: GetLayersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/sensor/layers?${stringifiedParams}` : `/sensor/layers`;
};

export const getLayers = async (params: GetLayersParams, options?: RequestInit): Promise<SensorLayerDTO[]> => {
    return getLayersMutator<SensorLayerDTO[]>(getGetLayersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetLayersKey = (params: GetLayersParams) => [`/sensor/layers`, ...(params ? [params] : [])] as const;

export type GetLayersQueryResult = NonNullable<Awaited<ReturnType<typeof getLayers>>>;
export type GetLayersQueryError = UtilHttpError;

/**
 * @summary Get layers by instance role
 */
export const useGetLayers = <TError = UtilHttpError>(
    params: GetLayersParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getLayers>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getLayersMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetLayersKey(params) : null));
    const swrFn = () => getLayers(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * This will autoupdate a devicegroup and also notify the sensors that they should track the new addresses
 * @summary MAC scan
 */
export const getMACScanUrl = () => {
    return `/sensor/scan`;
};

export const mACScan = async (
    sensorMACScanRequestDTO: SensorMACScanRequestDTO,
    options?: RequestInit,
): Promise<SensorMACScanResponse> => {
    return mACScanMutator<SensorMACScanResponse>(getMACScanUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sensorMACScanRequestDTO),
    });
};

export const getMACScanMutationFetcher = (options?: SecondParameter<typeof mACScanMutator>) => {
    return (_: Key, { arg }: { arg: SensorMACScanRequestDTO }) => {
        return mACScan(arg, options);
    };
};
export const getMACScanMutationKey = () => [`/sensor/scan`] as const;

export type MACScanMutationResult = NonNullable<Awaited<ReturnType<typeof mACScan>>>;
export type MACScanMutationError = UtilHttpError;

/**
 * @summary MAC scan
 */
export const useMACScan = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof mACScan>>,
        TError,
        Key,
        SensorMACScanRequestDTO,
        Awaited<ReturnType<typeof mACScan>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof mACScanMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMACScanMutationKey();
    const swrFn = getMACScanMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * List renki tags
 * @summary List renki tags
 */
export const getListRenkiTagsUrl = (params: ListRenkiTagsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/tag?${stringifiedParams}` : `/tag`;
};

export const listRenkiTags = async (
    params: ListRenkiTagsParams,
    options?: RequestInit,
): Promise<TagListRenkiTagsResponseDTO> => {
    return listRenkiTagsMutator<TagListRenkiTagsResponseDTO>(getListRenkiTagsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getListRenkiTagsKey = (params: ListRenkiTagsParams) => [`/tag`, ...(params ? [params] : [])] as const;

export type ListRenkiTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listRenkiTags>>>;
export type ListRenkiTagsQueryError = UtilHttpError;

/**
 * @summary List renki tags
 */
export const useListRenkiTags = <TError = UtilHttpError>(
    params: ListRenkiTagsParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof listRenkiTags>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof listRenkiTagsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListRenkiTagsKey(params) : null));
    const swrFn = () => listRenkiTags(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Claim tag
 * @summary Claim tag
 */
export const getClaimTagUrl = () => {
    return `/tag/claim`;
};

export const claimTag = async (tagClaimTagDTO: TagClaimTagDTO, options?: RequestInit): Promise<void> => {
    return claimTagMutator<void>(getClaimTagUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(tagClaimTagDTO),
    });
};

export const getClaimTagMutationFetcher = (options?: SecondParameter<typeof claimTagMutator>) => {
    return (_: Key, { arg }: { arg: TagClaimTagDTO }) => {
        return claimTag(arg, options);
    };
};
export const getClaimTagMutationKey = () => [`/tag/claim`] as const;

export type ClaimTagMutationResult = NonNullable<Awaited<ReturnType<typeof claimTag>>>;
export type ClaimTagMutationError = UtilHttpError;

/**
 * @summary Claim tag
 */
export const useClaimTag = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof claimTag>>,
        TError,
        Key,
        TagClaimTagDTO,
        Awaited<ReturnType<typeof claimTag>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof claimTagMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getClaimTagMutationKey();
    const swrFn = getClaimTagMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Will check if user has permissions to modify a serials redirect
 * @summary Has redirect permissions
 */
export const getHasRedirectPermissionsUrl = (serial: string) => {
    return `/tag/hasredirectpermissions/${serial}`;
};

export const hasRedirectPermissions = async (
    serial: string,
    options?: RequestInit,
): Promise<TagHasRedirectPermissionsResponseDTO> => {
    return hasRedirectPermissionsMutator<TagHasRedirectPermissionsResponseDTO>(getHasRedirectPermissionsUrl(serial), {
        ...options,
        method: 'GET',
    });
};

export const getHasRedirectPermissionsKey = (serial: string) => [`/tag/hasredirectpermissions/${serial}`] as const;

export type HasRedirectPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof hasRedirectPermissions>>>;
export type HasRedirectPermissionsQueryError = UtilHttpError;

/**
 * @summary Has redirect permissions
 */
export const useHasRedirectPermissions = <TError = UtilHttpError>(
    serial: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof hasRedirectPermissions>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof hasRedirectPermissionsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!serial;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getHasRedirectPermissionsKey(serial) : null));
    const swrFn = () => hasRedirectPermissions(serial, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * List all owned tags
 * @summary List all owned tags
 */
export const getListAllOwnedTagsUrl = (params: ListAllOwnedTagsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/tag/owned?${stringifiedParams}` : `/tag/owned`;
};

export const listAllOwnedTags = async (
    params: ListAllOwnedTagsParams,
    options?: RequestInit,
): Promise<TagListRenkiTagsResponseDTO> => {
    return listAllOwnedTagsMutator<TagListRenkiTagsResponseDTO>(getListAllOwnedTagsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getListAllOwnedTagsKey = (params: ListAllOwnedTagsParams) =>
    [`/tag/owned`, ...(params ? [params] : [])] as const;

export type ListAllOwnedTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllOwnedTags>>>;
export type ListAllOwnedTagsQueryError = UtilHttpError;

/**
 * @summary List all owned tags
 */
export const useListAllOwnedTags = <TError = UtilHttpError>(
    params: ListAllOwnedTagsParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof listAllOwnedTags>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof listAllOwnedTagsMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListAllOwnedTagsKey(params) : null));
    const swrFn = () => listAllOwnedTags(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Add tag link, will need the permissions to add the link to a tag.
 * @summary Add tag link
 */
export const getAddTagLinkUrl = () => {
    return `/tag/redirect`;
};

export const addTagLink = async (tagAddTagLinkDTO: TagAddTagLinkDTO, options?: RequestInit): Promise<void> => {
    return addTagLinkMutator<void>(getAddTagLinkUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(tagAddTagLinkDTO),
    });
};

export const getAddTagLinkMutationFetcher = (options?: SecondParameter<typeof addTagLinkMutator>) => {
    return (_: Key, { arg }: { arg: TagAddTagLinkDTO }) => {
        return addTagLink(arg, options);
    };
};
export const getAddTagLinkMutationKey = () => [`/tag/redirect`] as const;

export type AddTagLinkMutationResult = NonNullable<Awaited<ReturnType<typeof addTagLink>>>;
export type AddTagLinkMutationError = UtilHttpError;

/**
 * @summary Add tag link
 */
export const useAddTagLink = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof addTagLink>>,
        TError,
        Key,
        TagAddTagLinkDTO,
        Awaited<ReturnType<typeof addTagLink>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof addTagLinkMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getAddTagLinkMutationKey();
    const swrFn = getAddTagLinkMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get active redirect link for a tag (requires ownership or appropriate permissions)
 * @summary Get tag link
 */
export const getGetTagLinkUrl = (serial: string) => {
    return `/tag/redirect/${serial}`;
};

export const getTagLink = async (serial: string, options?: RequestInit): Promise<TagTagLinkResponseDTO> => {
    return getTagLinkMutator<TagTagLinkResponseDTO>(getGetTagLinkUrl(serial), {
        ...options,
        method: 'GET',
    });
};

export const getGetTagLinkKey = (serial: string) => [`/tag/redirect/${serial}`] as const;

export type GetTagLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getTagLink>>>;
export type GetTagLinkQueryError = UtilHttpError;

/**
 * @summary Get tag link
 */
export const useGetTagLink = <TError = UtilHttpError>(
    serial: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getTagLink>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getTagLinkMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!serial;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetTagLinkKey(serial) : null));
    const swrFn = () => getTagLink(serial, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Release tag
 * @summary Release tag
 */
export const getReleaseTagUrl = () => {
    return `/tag/release`;
};

export const releaseTag = async (
    tagReleaseTagRequestDTO: TagReleaseTagRequestDTO,
    options?: RequestInit,
): Promise<void> => {
    return releaseTagMutator<void>(getReleaseTagUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(tagReleaseTagRequestDTO),
    });
};

export const getReleaseTagMutationFetcher = (options?: SecondParameter<typeof releaseTagMutator>) => {
    return (_: Key, { arg }: { arg: TagReleaseTagRequestDTO }) => {
        return releaseTag(arg, options);
    };
};
export const getReleaseTagMutationKey = () => [`/tag/release`] as const;

export type ReleaseTagMutationResult = NonNullable<Awaited<ReturnType<typeof releaseTag>>>;
export type ReleaseTagMutationError = UtilHttpError;

/**
 * @summary Release tag
 */
export const useReleaseTag = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof releaseTag>>,
        TError,
        Key,
        TagReleaseTagRequestDTO,
        Awaited<ReturnType<typeof releaseTag>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof releaseTagMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getReleaseTagMutationKey();
    const swrFn = getReleaseTagMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get renki tag
 * @summary Get renki tag
 */
export const getGetRenkiTagUrl = (serial: string) => {
    return `/tag/${serial}`;
};

export const getRenkiTag = async (serial: string, options?: RequestInit): Promise<TagRenkiTagDTO> => {
    return getRenkiTagMutator<TagRenkiTagDTO>(getGetRenkiTagUrl(serial), {
        ...options,
        method: 'GET',
    });
};

export const getGetRenkiTagKey = (serial: string) => [`/tag/${serial}`] as const;

export type GetRenkiTagQueryResult = NonNullable<Awaited<ReturnType<typeof getRenkiTag>>>;
export type GetRenkiTagQueryError = UtilHttpError;

/**
 * @summary Get renki tag
 */
export const useGetRenkiTag = <TError = UtilHttpError>(
    serial: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getRenkiTag>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getRenkiTagMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!serial;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetRenkiTagKey(serial) : null));
    const swrFn = () => getRenkiTag(serial, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get renki tag type
 * @summary Get renki tag type
 */
export const getGetRenkiTagTypeUrl = (serial: string) => {
    return `/tag/${serial}/type`;
};

export const getRenkiTagType = async (serial: string, options?: RequestInit): Promise<TagRenkiTagTypeDTO> => {
    return getRenkiTagTypeMutator<TagRenkiTagTypeDTO>(getGetRenkiTagTypeUrl(serial), {
        ...options,
        method: 'GET',
    });
};

export const getGetRenkiTagTypeKey = (serial: string) => [`/tag/${serial}/type`] as const;

export type GetRenkiTagTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getRenkiTagType>>>;
export type GetRenkiTagTypeQueryError = UtilHttpError;

/**
 * @summary Get renki tag type
 */
export const useGetRenkiTagType = <TError = UtilHttpError>(
    serial: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getRenkiTagType>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getRenkiTagTypeMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!serial;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetRenkiTagTypeKey(serial) : null));
    const swrFn = () => getRenkiTagType(serial, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Internal scan endpoint for tauri
 * @summary First scan
 */
export const getFirstScanUrl = () => {
    return `/tauri/devicegroup`;
};

export const firstScan = async (
    sensorFirstScanRequestDTO: SensorFirstScanRequestDTO,
    options?: RequestInit,
): Promise<SensorFirstScanResponseDTO> => {
    return firstScanMutator<SensorFirstScanResponseDTO>(getFirstScanUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(sensorFirstScanRequestDTO),
    });
};

export const getFirstScanMutationFetcher = (options?: SecondParameter<typeof firstScanMutator>) => {
    return (_: Key, { arg }: { arg: SensorFirstScanRequestDTO }) => {
        return firstScan(arg, options);
    };
};
export const getFirstScanMutationKey = () => [`/tauri/devicegroup`] as const;

export type FirstScanMutationResult = NonNullable<Awaited<ReturnType<typeof firstScan>>>;
export type FirstScanMutationError = UtilHttpError;

/**
 * @summary First scan
 */
export const useFirstScan = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof firstScan>>,
        TError,
        Key,
        SensorFirstScanRequestDTO,
        Awaited<ReturnType<typeof firstScan>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof firstScanMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getFirstScanMutationKey();
    const swrFn = getFirstScanMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get latest tauri update
 * @summary Get latest tauri update
 */
export const getGetTauriUpdateUrl = (params: GetTauriUpdateParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/tauriupdate?${stringifiedParams}` : `/tauriupdate`;
};

export const getTauriUpdate = async (params: GetTauriUpdateParams, options?: RequestInit): Promise<TauriupdateDTO> => {
    return getTauriUpdateMutator<TauriupdateDTO>(getGetTauriUpdateUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetTauriUpdateKey = (params: GetTauriUpdateParams) =>
    [`/tauriupdate`, ...(params ? [params] : [])] as const;

export type GetTauriUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof getTauriUpdate>>>;
export type GetTauriUpdateQueryError = UtilHttpError;

/**
 * @summary Get latest tauri update
 */
export const useGetTauriUpdate = <TError = UtilHttpError>(
    params: GetTauriUpdateParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getTauriUpdate>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getTauriUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetTauriUpdateKey(params) : null));
    const swrFn = () => getTauriUpdate(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get a single integration by ID
 * @summary Get integration
 */
export const getGetIntegrationUrl = (tenantRole: string, id: string) => {
    return `/tenant/${tenantRole}/integrations/${id}`;
};

export const getIntegration = async (
    tenantRole: string,
    id: string,
    options?: RequestInit,
): Promise<IntegrationsIntegrationDTO> => {
    return getIntegrationMutator<IntegrationsIntegrationDTO>(getGetIntegrationUrl(tenantRole, id), {
        ...options,
        method: 'GET',
    });
};

export const getGetIntegrationKey = (tenantRole: string, id: string) =>
    [`/tenant/${tenantRole}/integrations/${id}`] as const;

export type GetIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegration>>>;
export type GetIntegrationQueryError = UtilHttpError;

/**
 * @summary Get integration
 */
export const useGetIntegration = <TError = UtilHttpError>(
    tenantRole: string,
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getIntegration>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getIntegrationMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!(tenantRole && id);
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetIntegrationKey(tenantRole, id) : null));
    const swrFn = () => getIntegration(tenantRole, id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Retrieve the latest version of the Terms of Service
 * @summary Get the latest Terms of Service
 */
export const getGetTosLatestUrl = () => {
    return `/tos/latest`;
};

export const getTosLatest = async (options?: RequestInit): Promise<TosDTO> => {
    return getTosLatestMutator<TosDTO>(getGetTosLatestUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetTosLatestKey = () => [`/tos/latest`] as const;

export type GetTosLatestQueryResult = NonNullable<Awaited<ReturnType<typeof getTosLatest>>>;
export type GetTosLatestQueryError = UtilHttpError;

/**
 * @summary Get the latest Terms of Service
 */
export const useGetTosLatest = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getTosLatest>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof getTosLatestMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetTosLatestKey() : null));
    const swrFn = () => getTosLatest(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete account
 * @summary Delete account
 */
export const getDeleteAccountUrl = () => {
    return `/user/account`;
};

export const deleteAccount = async (options?: RequestInit): Promise<void> => {
    return deleteAccountMutator<void>(getDeleteAccountUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getDeleteAccountMutationFetcher = (options?: SecondParameter<typeof deleteAccountMutator>) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteAccount(options);
    };
};
export const getDeleteAccountMutationKey = () => [`/user/account`] as const;

export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>;
export type DeleteAccountMutationError = UtilHttpError;

/**
 * @summary Delete account
 */
export const useDeleteAccount = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof deleteAccount>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof deleteAccountMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDeleteAccountMutationKey();
    const swrFn = getDeleteAccountMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get user account information
 * @summary Get user account information
 */
export const getGetCloakUserUrl = () => {
    return `/user/account`;
};

export const getCloakUser = async (options?: RequestInit): Promise<AccountGetUserAccountResponseDTO> => {
    return getCloakUserMutator<AccountGetUserAccountResponseDTO>(getGetCloakUserUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetCloakUserKey = () => [`/user/account`] as const;

export type GetCloakUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCloakUser>>>;
export type GetCloakUserQueryError = UtilHttpError;

/**
 * @summary Get user account information
 */
export const useGetCloakUser = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getCloakUser>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof getCloakUserMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetCloakUserKey() : null));
    const swrFn = () => getCloakUser(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Update user account information
 * @summary Update user account information
 */
export const getUpdateCloakUserUrl = () => {
    return `/user/account`;
};

export const updateCloakUser = async (
    accountPutUserAccountRequestDTO: AccountPutUserAccountRequestDTO,
    options?: RequestInit,
): Promise<void> => {
    return updateCloakUserMutator<void>(getUpdateCloakUserUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(accountPutUserAccountRequestDTO),
    });
};

export const getUpdateCloakUserMutationFetcher = (options?: SecondParameter<typeof updateCloakUserMutator>) => {
    return (_: Key, { arg }: { arg: AccountPutUserAccountRequestDTO }) => {
        return updateCloakUser(arg, options);
    };
};
export const getUpdateCloakUserMutationKey = () => [`/user/account`] as const;

export type UpdateCloakUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateCloakUser>>>;
export type UpdateCloakUserMutationError = UtilHttpError;

/**
 * @summary Update user account information
 */
export const useUpdateCloakUser = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof updateCloakUser>>,
        TError,
        Key,
        AccountPutUserAccountRequestDTO,
        Awaited<ReturnType<typeof updateCloakUser>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof updateCloakUserMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateCloakUserMutationKey();
    const swrFn = getUpdateCloakUserMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get user federated identities
 * @summary Get user federated identities
 */
export const getGetCloakUserFederatedIdentitiesUrl = () => {
    return `/user/account/federated-identities`;
};

export const getCloakUserFederatedIdentities = async (
    options?: RequestInit,
): Promise<AccountGetFederatedIdentityResponseDTO[]> => {
    return getCloakUserFederatedIdentitiesMutator<AccountGetFederatedIdentityResponseDTO[]>(
        getGetCloakUserFederatedIdentitiesUrl(),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetCloakUserFederatedIdentitiesKey = () => [`/user/account/federated-identities`] as const;

export type GetCloakUserFederatedIdentitiesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCloakUserFederatedIdentities>>
>;
export type GetCloakUserFederatedIdentitiesQueryError = UtilHttpError;

/**
 * @summary Get user federated identities
 */
export const useGetCloakUserFederatedIdentities = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getCloakUserFederatedIdentities>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof getCloakUserFederatedIdentitiesMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetCloakUserFederatedIdentitiesKey() : null));
    const swrFn = () => getCloakUserFederatedIdentities(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get user GDPR requests
 * @summary Get user GDPR requests
 */
export const getGetUserGDPRRequestsUrl = () => {
    return `/user/account/gdpr-requests`;
};

export const getUserGDPRRequests = async (options?: RequestInit): Promise<AccountGetUserGDPRRequestResponseDTO[]> => {
    return getUserGDPRRequestsMutator<AccountGetUserGDPRRequestResponseDTO[]>(getGetUserGDPRRequestsUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetUserGDPRRequestsKey = () => [`/user/account/gdpr-requests`] as const;

export type GetUserGDPRRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGDPRRequests>>>;
export type GetUserGDPRRequestsQueryError = UtilHttpError;

/**
 * @summary Get user GDPR requests
 */
export const useGetUserGDPRRequests = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getUserGDPRRequests>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof getUserGDPRRequestsMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetUserGDPRRequestsKey() : null));
    const swrFn = () => getUserGDPRRequests(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create user GDPR request
 * @summary Create user GDPR request
 */
export const getCreateUserGDPRRequestUrl = () => {
    return `/user/account/gdpr-requests`;
};

export const createUserGDPRRequest = async (options?: RequestInit): Promise<AccountGetUserGDPRRequestResponseDTO> => {
    return createUserGDPRRequestMutator<AccountGetUserGDPRRequestResponseDTO>(getCreateUserGDPRRequestUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getCreateUserGDPRRequestMutationFetcher = (
    options?: SecondParameter<typeof createUserGDPRRequestMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return createUserGDPRRequest(options);
    };
};
export const getCreateUserGDPRRequestMutationKey = () => [`/user/account/gdpr-requests`] as const;

export type CreateUserGDPRRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createUserGDPRRequest>>>;
export type CreateUserGDPRRequestMutationError = UtilHttpError;

/**
 * @summary Create user GDPR request
 */
export const useCreateUserGDPRRequest = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createUserGDPRRequest>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof createUserGDPRRequest>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createUserGDPRRequestMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateUserGDPRRequestMutationKey();
    const swrFn = getCreateUserGDPRRequestMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Leave instance
 * @summary Leave instance
 */
export const getLeaveInstanceUrl = (instance: string) => {
    return `/user/account/instance/${instance}`;
};

export const leaveInstance = async (instance: string, options?: RequestInit): Promise<void> => {
    return leaveInstanceMutator<void>(getLeaveInstanceUrl(instance), {
        ...options,
        method: 'DELETE',
    });
};

export const getLeaveInstanceMutationFetcher = (
    instance: string,
    options?: SecondParameter<typeof leaveInstanceMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return leaveInstance(instance, options);
    };
};
export const getLeaveInstanceMutationKey = (instance: string) => [`/user/account/instance/${instance}`] as const;

export type LeaveInstanceMutationResult = NonNullable<Awaited<ReturnType<typeof leaveInstance>>>;
export type LeaveInstanceMutationError = UtilHttpError;

/**
 * @summary Leave instance
 */
export const useLeaveInstance = <TError = UtilHttpError>(
    instance: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof leaveInstance>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof leaveInstance>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof leaveInstanceMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getLeaveInstanceMutationKey(instance);
    const swrFn = getLeaveInstanceMutationFetcher(instance, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Retrieves the Microsoft token
 * @summary Get Microsoft token
 */
export const getGetMSTokenUrl = () => {
    return `/user/account/microsoft/token`;
};

export const getMSToken = async (options?: RequestInit): Promise<AccountMicrosoftTokenResponseDTO> => {
    return getMSTokenMutator<AccountMicrosoftTokenResponseDTO>(getGetMSTokenUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetMSTokenKey = () => [`/user/account/microsoft/token`] as const;

export type GetMSTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getMSToken>>>;
export type GetMSTokenQueryError = UtilHttpError;

/**
 * @summary Get Microsoft token
 */
export const useGetMSToken = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getMSToken>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof getMSTokenMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetMSTokenKey() : null));
    const swrFn = () => getMSToken(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Logout all sessions
 * @summary Logout all sessions
 */
export const getLogoutAllSessionsUrl = () => {
    return `/user/account/sessions`;
};

export const logoutAllSessions = async (options?: RequestInit): Promise<void> => {
    return logoutAllSessionsMutator<void>(getLogoutAllSessionsUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getLogoutAllSessionsMutationFetcher = (options?: SecondParameter<typeof logoutAllSessionsMutator>) => {
    return (_: Key, __: { arg: Arguments }) => {
        return logoutAllSessions(options);
    };
};
export const getLogoutAllSessionsMutationKey = () => [`/user/account/sessions`] as const;

export type LogoutAllSessionsMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAllSessions>>>;
export type LogoutAllSessionsMutationError = UtilHttpError;

/**
 * @summary Logout all sessions
 */
export const useLogoutAllSessions = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof logoutAllSessions>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof logoutAllSessions>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof logoutAllSessionsMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getLogoutAllSessionsMutationKey();
    const swrFn = getLogoutAllSessionsMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get user sessions
 * @summary Get user sessions
 */
export const getGetUserSessionsUrl = () => {
    return `/user/account/sessions`;
};

export const getUserSessions = async (options?: RequestInit): Promise<AccountGetSessionsResponseDTO> => {
    return getUserSessionsMutator<AccountGetSessionsResponseDTO>(getGetUserSessionsUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetUserSessionsKey = () => [`/user/account/sessions`] as const;

export type GetUserSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSessions>>>;
export type GetUserSessionsQueryError = UtilHttpError;

/**
 * @summary Get user sessions
 */
export const useGetUserSessions = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getUserSessions>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof getUserSessionsMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetUserSessionsKey() : null));
    const swrFn = () => getUserSessions(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get the active instance for the authenticated user
 * @summary Get user active instance
 */
export const getGetUserActiveInstanceUrl = () => {
    return `/user/active-instance`;
};

export const getUserActiveInstance = async (options?: RequestInit): Promise<UserActiveInstanceResponseDTO> => {
    return getUserActiveInstanceMutator<UserActiveInstanceResponseDTO>(getGetUserActiveInstanceUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetUserActiveInstanceKey = () => [`/user/active-instance`] as const;

export type GetUserActiveInstanceQueryResult = NonNullable<Awaited<ReturnType<typeof getUserActiveInstance>>>;
export type GetUserActiveInstanceQueryError = UtilHttpError;

/**
 * @summary Get user active instance
 */
export const useGetUserActiveInstance = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getUserActiveInstance>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof getUserActiveInstanceMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetUserActiveInstanceKey() : null));
    const swrFn = () => getUserActiveInstance(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device groups
 * @summary Get device groups
 */
export const getGetDeviceGroupsUrl = () => {
    return `/user/devicegroup`;
};

export const getDeviceGroups = async (options?: RequestInit): Promise<UserUIDeviceGroupResponseDTO[]> => {
    return getDeviceGroupsMutator<UserUIDeviceGroupResponseDTO[]>(getGetDeviceGroupsUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetDeviceGroupsKey = () => [`/user/devicegroup`] as const;

export type GetDeviceGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceGroups>>>;
export type GetDeviceGroupsQueryError = UtilHttpError;

/**
 * @summary Get device groups
 */
export const useGetDeviceGroups = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceGroups>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof getDeviceGroupsMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceGroupsKey() : null));
    const swrFn = () => getDeviceGroups(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create device group
 * @summary Create device group
 */
export const getCreateDeviceGroupUrl = () => {
    return `/user/devicegroup`;
};

export const createDeviceGroup = async (
    userCreateDeviceGroupRequestDTO: UserCreateDeviceGroupRequestDTO,
    options?: RequestInit,
): Promise<UserDeviceGroupDTO> => {
    return createDeviceGroupMutator<UserDeviceGroupDTO>(getCreateDeviceGroupUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userCreateDeviceGroupRequestDTO),
    });
};

export const getCreateDeviceGroupMutationFetcher = (options?: SecondParameter<typeof createDeviceGroupMutator>) => {
    return (_: Key, { arg }: { arg: UserCreateDeviceGroupRequestDTO }) => {
        return createDeviceGroup(arg, options);
    };
};
export const getCreateDeviceGroupMutationKey = () => [`/user/devicegroup`] as const;

export type CreateDeviceGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createDeviceGroup>>>;
export type CreateDeviceGroupMutationError = UtilHttpError;

/**
 * @summary Create device group
 */
export const useCreateDeviceGroup = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createDeviceGroup>>,
        TError,
        Key,
        UserCreateDeviceGroupRequestDTO,
        Awaited<ReturnType<typeof createDeviceGroup>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createDeviceGroupMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateDeviceGroupMutationKey();
    const swrFn = getCreateDeviceGroupMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get user device groups last seen
 * @summary Get user device groups last seen
 */
export const getGetUserDeviceGroupsLastSeenUrl = (params?: GetUserDeviceGroupsLastSeenParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/user/devicegroup/onlinedata?${stringifiedParams}`
        : `/user/devicegroup/onlinedata`;
};

export const getUserDeviceGroupsLastSeen = async (
    params?: GetUserDeviceGroupsLastSeenParams,
    options?: RequestInit,
): Promise<UserDeviceGroupsLastSeenDTO[]> => {
    return getUserDeviceGroupsLastSeenMutator<UserDeviceGroupsLastSeenDTO[]>(
        getGetUserDeviceGroupsLastSeenUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetUserDeviceGroupsLastSeenKey = (params?: GetUserDeviceGroupsLastSeenParams) =>
    [`/user/devicegroup/onlinedata`, ...(params ? [params] : [])] as const;

export type GetUserDeviceGroupsLastSeenQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserDeviceGroupsLastSeen>>
>;
export type GetUserDeviceGroupsLastSeenQueryError = UtilHttpError;

/**
 * @summary Get user device groups last seen
 */
export const useGetUserDeviceGroupsLastSeen = <TError = UtilHttpError>(
    params?: GetUserDeviceGroupsLastSeenParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getUserDeviceGroupsLastSeen>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getUserDeviceGroupsLastSeenMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetUserDeviceGroupsLastSeenKey(params) : null));
    const swrFn = () => getUserDeviceGroupsLastSeen(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete device group
 * @summary Delete device group
 */
export const getDeleteDeviceGroupUrl = (id: string) => {
    return `/user/devicegroup/${id}`;
};

export const deleteDeviceGroup = async (id: string, options?: RequestInit): Promise<void> => {
    return deleteDeviceGroupMutator<void>(getDeleteDeviceGroupUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDeleteDeviceGroupMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof deleteDeviceGroupMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteDeviceGroup(id, options);
    };
};
export const getDeleteDeviceGroupMutationKey = (id: string) => [`/user/devicegroup/${id}`] as const;

export type DeleteDeviceGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDeviceGroup>>>;
export type DeleteDeviceGroupMutationError = UtilHttpError;

/**
 * @summary Delete device group
 */
export const useDeleteDeviceGroup = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteDeviceGroup>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof deleteDeviceGroup>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteDeviceGroupMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDeleteDeviceGroupMutationKey(id);
    const swrFn = getDeleteDeviceGroupMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device group by ID
 * @summary Get device group by ID
 */
export const getGetDeviceGroupByIDUrl = (id: string) => {
    return `/user/devicegroup/${id}`;
};

export const getDeviceGroupByID = async (id: string, options?: RequestInit): Promise<UserUIDeviceGroupResponseDTO> => {
    return getDeviceGroupByIDMutator<UserUIDeviceGroupResponseDTO>(getGetDeviceGroupByIDUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getGetDeviceGroupByIDKey = (id: string) => [`/user/devicegroup/${id}`] as const;

export type GetDeviceGroupByIDQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceGroupByID>>>;
export type GetDeviceGroupByIDQueryError = UtilHttpError;

/**
 * @summary Get device group by ID
 */
export const useGetDeviceGroupByID = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceGroupByID>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceGroupByIDMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceGroupByIDKey(id) : null));
    const swrFn = () => getDeviceGroupByID(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Update device group
 * @summary Update device group
 */
export const getUpdateDeviceGroupUrl = (id: string) => {
    return `/user/devicegroup/${id}`;
};

export const updateDeviceGroup = async (
    id: string,
    userUpdateDeviceGroupRequestBodyDTO: UserUpdateDeviceGroupRequestBodyDTO,
    options?: RequestInit,
): Promise<UserDeviceGroupDTO> => {
    return updateDeviceGroupMutator<UserDeviceGroupDTO>(getUpdateDeviceGroupUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userUpdateDeviceGroupRequestBodyDTO),
    });
};

export const getUpdateDeviceGroupMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof updateDeviceGroupMutator>,
) => {
    return (_: Key, { arg }: { arg: UserUpdateDeviceGroupRequestBodyDTO }) => {
        return updateDeviceGroup(id, arg, options);
    };
};
export const getUpdateDeviceGroupMutationKey = (id: string) => [`/user/devicegroup/${id}`] as const;

export type UpdateDeviceGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceGroup>>>;
export type UpdateDeviceGroupMutationError = UtilHttpError;

/**
 * @summary Update device group
 */
export const useUpdateDeviceGroup = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof updateDeviceGroup>>,
            TError,
            Key,
            UserUpdateDeviceGroupRequestBodyDTO,
            Awaited<ReturnType<typeof updateDeviceGroup>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof updateDeviceGroupMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateDeviceGroupMutationKey(id);
    const swrFn = getUpdateDeviceGroupMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete addresses
 * @summary Delete addresses
 */
export const getDeleteAddressesUrl = (id: string) => {
    return `/user/devicegroup/${id}/addresses`;
};

export const deleteAddresses = async (
    id: string,
    userCreateDeviceGroupAddressesBodyDTO: UserCreateDeviceGroupAddressesBodyDTO,
    options?: RequestInit,
): Promise<void> => {
    return deleteAddressesMutator<void>(getDeleteAddressesUrl(id), {
        ...options,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userCreateDeviceGroupAddressesBodyDTO),
    });
};

export const getDeleteAddressesMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof deleteAddressesMutator>,
) => {
    return (_: Key, { arg }: { arg: UserCreateDeviceGroupAddressesBodyDTO }) => {
        return deleteAddresses(id, arg, options);
    };
};
export const getDeleteAddressesMutationKey = (id: string) => [`/user/devicegroup/${id}/addresses`] as const;

export type DeleteAddressesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddresses>>>;
export type DeleteAddressesMutationError = UtilHttpError;

/**
 * @summary Delete addresses
 */
export const useDeleteAddresses = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteAddresses>>,
            TError,
            Key,
            UserCreateDeviceGroupAddressesBodyDTO,
            Awaited<ReturnType<typeof deleteAddresses>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteAddressesMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDeleteAddressesMutationKey(id);
    const swrFn = getDeleteAddressesMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create addresses with hashed addresses
 * @summary Create addresses
 */
export const getCreateAddressesUrl = (id: string) => {
    return `/user/devicegroup/${id}/addresses`;
};

export const createAddresses = async (
    id: string,
    userCreateDeviceGroupAddressesBodyHashedDTO: UserCreateDeviceGroupAddressesBodyHashedDTO,
    options?: RequestInit,
): Promise<void> => {
    return createAddressesMutator<void>(getCreateAddressesUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userCreateDeviceGroupAddressesBodyHashedDTO),
    });
};

export const getCreateAddressesMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof createAddressesMutator>,
) => {
    return (_: Key, { arg }: { arg: UserCreateDeviceGroupAddressesBodyHashedDTO }) => {
        return createAddresses(id, arg, options);
    };
};
export const getCreateAddressesMutationKey = (id: string) => [`/user/devicegroup/${id}/addresses`] as const;

export type CreateAddressesMutationResult = NonNullable<Awaited<ReturnType<typeof createAddresses>>>;
export type CreateAddressesMutationError = UtilHttpError;

/**
 * @summary Create addresses
 */
export const useCreateAddresses = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof createAddresses>>,
            TError,
            Key,
            UserCreateDeviceGroupAddressesBodyHashedDTO,
            Awaited<ReturnType<typeof createAddresses>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof createAddressesMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateAddressesMutationKey(id);
    const swrFn = getCreateAddressesMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create addresses plain
 * @summary Create addresses
 */
export const getCreateAddressesPlainUrl = (id: string) => {
    return `/user/devicegroup/${id}/addressesplain`;
};

export const createAddressesPlain = async (
    id: string,
    userCreateDeviceGroupAddressesBodyDTO: UserCreateDeviceGroupAddressesBodyDTO,
    options?: RequestInit,
): Promise<void> => {
    return createAddressesPlainMutator<void>(getCreateAddressesPlainUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userCreateDeviceGroupAddressesBodyDTO),
    });
};

export const getCreateAddressesPlainMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof createAddressesPlainMutator>,
) => {
    return (_: Key, { arg }: { arg: UserCreateDeviceGroupAddressesBodyDTO }) => {
        return createAddressesPlain(id, arg, options);
    };
};
export const getCreateAddressesPlainMutationKey = (id: string) => [`/user/devicegroup/${id}/addressesplain`] as const;

export type CreateAddressesPlainMutationResult = NonNullable<Awaited<ReturnType<typeof createAddressesPlain>>>;
export type CreateAddressesPlainMutationError = UtilHttpError;

/**
 * @summary Create addresses
 */
export const useCreateAddressesPlain = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof createAddressesPlain>>,
            TError,
            Key,
            UserCreateDeviceGroupAddressesBodyDTO,
            Awaited<ReturnType<typeof createAddressesPlain>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof createAddressesPlainMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateAddressesPlainMutationKey(id);
    const swrFn = getCreateAddressesPlainMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get user device group last seen
 * @summary Get user device group last seen
 */
export const getGetUserDevicegroupIdOnlinedataUrl = (id: string) => {
    return `/user/devicegroup/${id}/onlinedata`;
};

export const getUserDevicegroupIdOnlinedata = async (
    id: string,
    options?: RequestInit,
): Promise<UserDeviceGroupsLastSeenDTO> => {
    return getUserDevicegroupIdOnlinedataMutator<UserDeviceGroupsLastSeenDTO>(
        getGetUserDevicegroupIdOnlinedataUrl(id),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetUserDevicegroupIdOnlinedataKey = (id: string) => [`/user/devicegroup/${id}/onlinedata`] as const;

export type GetUserDevicegroupIdOnlinedataQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserDevicegroupIdOnlinedata>>
>;
export type GetUserDevicegroupIdOnlinedataQueryError = UtilHttpError;

/**
 * @summary Get user device group last seen
 */
export const useGetUserDevicegroupIdOnlinedata = <TError = UtilHttpError>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getUserDevicegroupIdOnlinedata>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getUserDevicegroupIdOnlinedataMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetUserDevicegroupIdOnlinedataKey(id) : null));
    const swrFn = () => getUserDevicegroupIdOnlinedata(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Cancel hidden time for user
 * @summary Cancel hidden time
 */
export const getCancelHiddenTimeUrl = () => {
    return `/user/hiddentime`;
};

export const cancelHiddenTime = async (options?: RequestInit): Promise<void> => {
    return cancelHiddenTimeMutator<void>(getCancelHiddenTimeUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getCancelHiddenTimeMutationFetcher = (options?: SecondParameter<typeof cancelHiddenTimeMutator>) => {
    return (_: Key, __: { arg: Arguments }) => {
        return cancelHiddenTime(options);
    };
};
export const getCancelHiddenTimeMutationKey = () => [`/user/hiddentime`] as const;

export type CancelHiddenTimeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelHiddenTime>>>;
export type CancelHiddenTimeMutationError = UtilHttpError;

/**
 * @summary Cancel hidden time
 */
export const useCancelHiddenTime = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof cancelHiddenTime>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof cancelHiddenTime>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof cancelHiddenTimeMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCancelHiddenTimeMutationKey();
    const swrFn = getCancelHiddenTimeMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get hidden time for user
 * @summary Get hidden time
 */
export const getGetHiddenTimeUrl = (params?: GetHiddenTimeParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/user/hiddentime?${stringifiedParams}` : `/user/hiddentime`;
};

export const getHiddenTime = async (params?: GetHiddenTimeParams, options?: RequestInit): Promise<HiddentimeDTO[]> => {
    return getHiddenTimeMutator<HiddentimeDTO[]>(getGetHiddenTimeUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetHiddenTimeKey = (params?: GetHiddenTimeParams) =>
    [`/user/hiddentime`, ...(params ? [params] : [])] as const;

export type GetHiddenTimeQueryResult = NonNullable<Awaited<ReturnType<typeof getHiddenTime>>>;
export type GetHiddenTimeQueryError = UtilHttpError;

/**
 * @summary Get hidden time
 */
export const useGetHiddenTime = <TError = UtilHttpError>(
    params?: GetHiddenTimeParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getHiddenTime>>, TError> & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof getHiddenTimeMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetHiddenTimeKey(params) : null));
    const swrFn = () => getHiddenTime(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create hidden time for user
 * @summary Create hidden time
 */
export const getCreateHiddenTimeUrl = () => {
    return `/user/hiddentime`;
};

export const createHiddenTime = async (
    hiddentimeCreateRequestDTO: HiddentimeCreateRequestDTO,
    options?: RequestInit,
): Promise<HiddentimeDTO> => {
    return createHiddenTimeMutator<HiddentimeDTO>(getCreateHiddenTimeUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(hiddentimeCreateRequestDTO),
    });
};

export const getCreateHiddenTimeMutationFetcher = (options?: SecondParameter<typeof createHiddenTimeMutator>) => {
    return (_: Key, { arg }: { arg: HiddentimeCreateRequestDTO }) => {
        return createHiddenTime(arg, options);
    };
};
export const getCreateHiddenTimeMutationKey = () => [`/user/hiddentime`] as const;

export type CreateHiddenTimeMutationResult = NonNullable<Awaited<ReturnType<typeof createHiddenTime>>>;
export type CreateHiddenTimeMutationError = UtilHttpError;

/**
 * @summary Create hidden time
 */
export const useCreateHiddenTime = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createHiddenTime>>,
        TError,
        Key,
        HiddentimeCreateRequestDTO,
        Awaited<ReturnType<typeof createHiddenTime>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createHiddenTimeMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateHiddenTimeMutationKey();
    const swrFn = getCreateHiddenTimeMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get all metadata by user ID
 * @summary List all metadata by user ID
 */
export const getListMetadataByUserIDUrl = () => {
    return `/user/metadata`;
};

export const listMetadataByUserID = async (options?: RequestInit): Promise<UserAllInstallationsMetadataDTO> => {
    return listMetadataByUserIDMutator<UserAllInstallationsMetadataDTO>(getListMetadataByUserIDUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getListMetadataByUserIDKey = () => [`/user/metadata`] as const;

export type ListMetadataByUserIDQueryResult = NonNullable<Awaited<ReturnType<typeof listMetadataByUserID>>>;
export type ListMetadataByUserIDQueryError = UtilHttpError;

/**
 * @summary List all metadata by user ID
 */
export const useListMetadataByUserID = <TError = UtilHttpError>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listMetadataByUserID>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof listMetadataByUserIDMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListMetadataByUserIDKey() : null));
    const swrFn = () => listMetadataByUserID(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Create metadata
 * @summary Create metadata
 */
export const getCreateMetadataUrl = () => {
    return `/user/metadata`;
};

export const createMetadata = async (options?: RequestInit): Promise<UserInstallationMetadataDTO> => {
    return createMetadataMutator<UserInstallationMetadataDTO>(getCreateMetadataUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getCreateMetadataMutationFetcher = (options?: SecondParameter<typeof createMetadataMutator>) => {
    return (_: Key, __: { arg: Arguments }) => {
        return createMetadata(options);
    };
};
export const getCreateMetadataMutationKey = () => [`/user/metadata`] as const;

export type CreateMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof createMetadata>>>;
export type CreateMetadataMutationError = UtilHttpError;

/**
 * @summary Create metadata
 */
export const useCreateMetadata = <TError = UtilHttpError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof createMetadata>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof createMetadata>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof createMetadataMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getCreateMetadataMutationKey();
    const swrFn = getCreateMetadataMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get device installation metadata
 * @summary Get device installation metadata
 */
export const getGetDeviceInstallationMetadataUrl = (params: GetDeviceInstallationMetadataParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/user/metadata/device?${stringifiedParams}` : `/user/metadata/device`;
};

export const getDeviceInstallationMetadata = async (
    params: GetDeviceInstallationMetadataParams,
    options?: RequestInit,
): Promise<UserInstallationMetadataDTO> => {
    return getDeviceInstallationMetadataMutator<UserInstallationMetadataDTO>(
        getGetDeviceInstallationMetadataUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetDeviceInstallationMetadataKey = (params: GetDeviceInstallationMetadataParams) =>
    [`/user/metadata/device`, ...(params ? [params] : [])] as const;

export type GetDeviceInstallationMetadataQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDeviceInstallationMetadata>>
>;
export type GetDeviceInstallationMetadataQueryError = UtilHttpError;

/**
 * @summary Get device installation metadata
 */
export const useGetDeviceInstallationMetadata = <TError = UtilHttpError>(
    params: GetDeviceInstallationMetadataParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceInstallationMetadata>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceInstallationMetadataMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceInstallationMetadataKey(params) : null));
    const swrFn = () => getDeviceInstallationMetadata(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};
